import React__default, { useContext } from 'react';
import { createPortal } from 'react-dom';
import { M as MODAL_ROOT } from '../index-a9101009.js';
import { a as LocalizationContext } from '../LocalizationContext-a82461b5.js';
import Button, { ButtonTypes } from './Button.js';
import Icon, { IconTypes, IconColors } from './Icon.js';
import IconButton from './IconButton.js';
import { L as Label, a as LabelTypography, b as LabelColors } from '../index-6420013c.js';
import { u as useMediaQueryContext } from '../MediaQueryContext-d6110905.js';
import '../stringSet-b60e9529.js';
import '../index-6add7940.js';
import 'prop-types';
import '../_rollupPluginBabelHelpers-05128ded.js';
var ModalHeader = function ModalHeader(_ref) {
  var titleText = _ref.titleText;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-modal__header"
  }, /*#__PURE__*/React__default.createElement(Label, {
    type: LabelTypography.H_1,
    color: LabelColors.ONBACKGROUND_1
  }, titleText));
};
var ModalBody = function ModalBody(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-modal__body"
  }, /*#__PURE__*/React__default.createElement(Label, {
    type: LabelTypography.SUBTITLE_1,
    color: LabelColors.ONBACKGROUND_2
  }, children));
};
var ModalFooter = function ModalFooter(_ref3) {
  var submitText = _ref3.submitText,
    _ref3$disabled = _ref3.disabled,
    disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
    _ref3$type = _ref3.type,
    type = _ref3$type === void 0 ? ButtonTypes.DANGER : _ref3$type,
    onSubmit = _ref3.onSubmit,
    onCancel = _ref3.onCancel;
  var _useContext = useContext(LocalizationContext),
    stringSet = _useContext.stringSet;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-modal__footer"
  }, /*#__PURE__*/React__default.createElement(Button, {
    type: ButtonTypes.SECONDARY,
    onClick: onCancel
  }, /*#__PURE__*/React__default.createElement(Label, {
    type: LabelTypography.BUTTON_1,
    color: LabelColors.ONBACKGROUND_1
  }, stringSet.BUTTON__CANCEL)), /*#__PURE__*/React__default.createElement(Button, {
    type: type,
    disabled: disabled,
    onClick: onSubmit
  }, submitText));
};
function Modal(props) {
  var _props$children = props.children,
    children = _props$children === void 0 ? null : _props$children,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$isCloseOnClick = props.isCloseOnClickOutside,
    isCloseOnClickOutside = _props$isCloseOnClick === void 0 ? false : _props$isCloseOnClick,
    _props$isFullScreenOn = props.isFullScreenOnMobile,
    isFullScreenOnMobile = _props$isFullScreenOn === void 0 ? false : _props$isFullScreenOn,
    titleText = props.titleText,
    submitText = props.submitText,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$hideFooter = props.hideFooter,
    hideFooter = _props$hideFooter === void 0 ? false : _props$hideFooter,
    _props$type = props.type,
    type = _props$type === void 0 ? ButtonTypes.DANGER : _props$type,
    _props$onCancel = props.onCancel,
    onCancel = _props$onCancel === void 0 ? function () {/* noop */} : _props$onCancel,
    _props$onSubmit = props.onSubmit,
    onSubmit = _props$onSubmit === void 0 ? function () {/* noop */} : _props$onSubmit,
    renderHeader = props.renderHeader;
  var _useMediaQueryContext = useMediaQueryContext(),
    isMobile = _useMediaQueryContext.isMobile;
  return /*#__PURE__*/createPortal(/*#__PURE__*/React__default.createElement("div", {
    className: "\n      sendbird-modal ".concat(className, "\n      ").concat(isFullScreenOnMobile && isMobile ? 'sendbird-modal--full-mobile' : '', "\n    ")
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-modal__content"
  }, (renderHeader === null || renderHeader === void 0 ? void 0 : renderHeader()) || /*#__PURE__*/React__default.createElement(ModalHeader, {
    titleText: titleText
  }), /*#__PURE__*/React__default.createElement(ModalBody, null, children), !hideFooter && /*#__PURE__*/React__default.createElement(ModalFooter, {
    disabled: disabled,
    onCancel: onCancel,
    onSubmit: onSubmit,
    submitText: submitText,
    type: type
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-modal__close"
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    width: "32px",
    height: "32px",
    onClick: onCancel
  }, /*#__PURE__*/React__default.createElement(Icon, {
    type: IconTypes.CLOSE,
    fillColor: IconColors.DEFAULT,
    width: "24px",
    height: "24px"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "\n          sendbird-modal__backdrop\n          ".concat(isCloseOnClickOutside && 'sendbird-modal__backdrop--clickoutside', "\n        "),
    onClick: function onClick(e) {
      e === null || e === void 0 ? void 0 : e.stopPropagation();
      if (isCloseOnClickOutside) {
        onCancel();
      }
    }
  })), document.getElementById(MODAL_ROOT));
}
export { ModalBody, ModalFooter, ModalHeader, Modal as default };